import { callFetch } from './serviceHelpers';

export const getMerchantById = merchantId =>
  callFetch(process.env.REACT_APP_MERCHANT_CONFIG_URL, 'GET', `v0/merchants/${merchantId}`);
